<template>
    <div class="pagination-controls">
      <div class="pagination-show">
        <label for="itemsPerPage">Show</label>
        <select id="itemsPerPage" v-model="itemsPerPage" @change="$emit('change-items-per-page', itemsPerPage)">
          <option v-for="option in pageOptions" :key="option" :value="option">
            {{ option }}
          </option>
        </select>
      </div>
      <ul class="pagination">
        <li :class="{ disabled: currentPage === 1 }" @click="changePage(currentPage - 1)">
          <span>Previous</span>
        </li>
        <li
          v-for="page in visiblePages"
          :key="page.key"
          :class="{ active: currentPage === page.value, ellipsis: page.ellipsis }"
          @click="!page.ellipsis && changePage(page.value)"
        >
          <span>{{ page.display }}</span>
        </li>
        <li :class="{ disabled: currentPage === totalPages }" @click="changePage(currentPage + 1)">
          <span>Next</span>
        </li>
      </ul>
    </div>
  </template>
  
  <script>
  export default {
    props: {
      currentPage: {
        type: Number,
        required: true
      },
      totalPages: {
        type: Number,
        required: true
      },
      itemsPerPage: {
        type: Number,
        required: true
      },
      pageOptions: {
        type: Array,
        default: () => [5, 10, 15, 20]
      },
      maxVisiblePages: { type: Number, default: 7 }
    },
    computed: {
      visiblePages() {
        const pages = [];
        const total = this.totalPages;
        const current = this.currentPage;
        const max = this.maxVisiblePages;
        if (total <= max) {
          for (let i = 1; i <= total; i++) pages.push({ value: i, display: i, key: i });
        } else {
          let start = Math.max(1, current - Math.floor(max / 2));
          let end = start + max - 1;
          if (end > total) {
            end = total;
            start = end - max + 1;
          }

          if (start > 1) pages.push({ value: 1, display: 1, key: 1 });
          if (start > 2) pages.push({ value: null, display: '...', key: 'start-ellipsis', ellipsis: true });

          for (let i = start; i <= end; i++) pages.push({ value: i, display: i, key: i });

          if (end < total - 1) pages.push({ value: null, display: '...', key: 'end-ellipsis', ellipsis: true });
          if (end < total) pages.push({ value: total, display: total, key: total });
        }
        return pages;
      }
    },
    methods: {
      changePage(page) {
        if (page > 0 && page <= this.totalPages) {
          this.$emit('change-page', page);
        }
      }
    }
  };
  </script>
  
<style scoped>
.pagination-controls {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-top: 10px;
}
.pagination-show select {
  margin-left: 5px;
}
ul.pagination {
  display: flex;
  list-style: none;
  padding: 0;
}
ul.pagination li {
  cursor: pointer;
  padding: 4px 12px;
  border: 1px solid #ccc;
  border-radius: 4px;
}
ul.pagination li.active {
  background-color: #435851;
  color: white;
}
ul.pagination li.disabled {
  cursor: not-allowed;
  opacity: 0.5;
}
ul.pagination li.ellipsis {
  cursor: default;
}
</style>


// WEBPACK FOOTER //
// src/components/UIComponents/PaginationComponent.vue